const runWhenVisible = (element, onEnter, onLeave, rootMargin = '120px 0px') => {
    if (!element) return

    if (!('IntersectionObserver' in window)) {
        onEnter()
        return
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                onEnter()
            } else {
                onLeave()
            }
        })
    }, { threshold: 0, rootMargin })

    observer.observe(element)
}

const pauseSectionVideos = (section) => {
    section.querySelectorAll('video').forEach(video => {
        video.pause()
        video.muted = true
        video.closest('.video-wrapper-tiktok')?.classList.remove('is-playing')
    })
}

const playVideo = (video) => {
    const playPromise = video.play()

    if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {})
    }
}

/* Instagram Feed */
const initInstagramGallery = (root = document) => {
    root.querySelectorAll('.instagram-feed').forEach(section => {
        if (section.dataset.sectionsInitialized === 'true') return

        const element = section.querySelector('.splide')
        if (!element) return

        section.dataset.sectionsInitialized = 'true'

        let speed = Number(element.dataset.speed)

        if (element.dataset.direction === 'right') {
            speed = -Math.abs(speed)
        }

        const mySplide = new Splide(element, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            arrows: element.dataset.arrows === 'true',
            pagination: false,
            easing: element.dataset.easing,
            gap: Number(element.dataset.gap),
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: 0 },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            },
            autoScroll: {
                speed
            },
            direction: document.documentElement.getAttribute('dir')
        })
        mySplide.mount(window.splide.Extensions)

        runWhenVisible(section, () => {
            mySplide.Components.AutoScroll?.play()
        }, () => {
            mySplide.Components.AutoScroll?.pause()
        })
    })
}
initInstagramGallery()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.instagram-feed')) {
        initInstagramGallery(e.target)
    }
})

/* TikTok Slider */
const initTikTokSlider = (root = document) => {
    root.querySelectorAll('.tiktok-slider').forEach(section => {
        if (section.dataset.sectionsInitialized === 'true') return

        const element = section.querySelector('.splide')
        if (!element) return

        section.dataset.sectionsInitialized = 'true'
        section.dataset.viewportActive = 'false'

        const mySplide = new Splide(element, {
            arrows: element.dataset.arrows === 'true',
            pagination: false,
            easing: element.dataset.easing,
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            gap: Number(element.dataset.gap),
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: '15%' },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            },
            direction: document.documentElement.getAttribute('dir')
        })
        mySplide.mount()

        section.querySelectorAll('video').forEach(video => {
            const videoWrapper = video.closest('.video-wrapper-tiktok')
            const soundBtn = videoWrapper.querySelector('[data-toggle-sound]')

            video.addEventListener('click', (e) => {
                section.querySelectorAll(`video:not([data-index="${video.dataset.index}"])`).forEach(video => {
                    video.pause()
                    video.closest('.video-wrapper-tiktok').classList.remove('is-playing')
                })

                if (videoWrapper.classList.contains('is-playing')) {
                    video.pause()
                    videoWrapper.classList.remove('is-playing')
                } else {
                    playVideo(video)
                    videoWrapper.classList.add('is-playing')

                    if (section.dataset.volume === 'on') {
                        video.muted = false
                        soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
                        soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
                    }
                }
            })

            soundBtn?.addEventListener('click', () => {
                video.muted = !video.muted

                if (video.muted) {
                    soundBtn.querySelector('.icon-volume-off').removeAttribute('hidden')
                    soundBtn.querySelector('.icon-volume-on').setAttribute('hidden', 'hidden')
                    section.setAttribute('data-volume', 'off')
                } else {
                    soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
                    soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
                    section.setAttribute('data-volume', 'on')
                }
            })
        })

        mySplide.on('moved', (newIndex, prevIndex) => {
            const video = section.querySelector(`video[data-index="${newIndex}"]`)
            if (!video) return

            const videoWrapper = video.closest('.video-wrapper-tiktok')
            const soundBtn = videoWrapper.querySelector('[data-toggle-sound]')

            section.querySelectorAll(`video:not([data-index="${newIndex}"])`).forEach(video => {
                video.muted = true
                video.pause()
                video.closest('.video-wrapper-tiktok').classList.remove('is-playing')
            })

            if (section.dataset.viewportActive !== 'true') {
                video.pause()
                videoWrapper.classList.remove('is-playing')
                return
            }

            playVideo(video)

            videoWrapper.classList.add('is-playing')

            if (section.dataset.volume === 'on' && !navigator.userAgent.match(/(iPad|iPhone)/g)) {
                video.muted = false
                soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
                soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
            }
        })

        runWhenVisible(section, () => {
            section.dataset.viewportActive = 'true'
            mySplide.Components.Autoplay?.play()
        }, () => {
            section.dataset.viewportActive = 'false'
            mySplide.Components.Autoplay?.pause()
            pauseSectionVideos(section)
        })
    })
}
initTikTokSlider()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.tiktok-slider')) {
        initTikTokSlider(e.target)
    }
})


/*
    Marquee
*/
const initMarqueeSections = (root = document) => {
    root.querySelectorAll('.marquee').forEach(section => {
        if (section.dataset.sectionsInitialized === 'true') return

        const list = section.querySelector('ul')
        if (!list) return

        section.dataset.sectionsInitialized = 'true'
        const marqueeWidth = list.scrollWidth
        const marqueeLength = list.querySelectorAll('li').length

        list.insertAdjacentHTML('beforeEnd', list.innerHTML)
        list.insertAdjacentHTML('beforeEnd', list.innerHTML)

        list.querySelectorAll('li').forEach((item, index) => {
            if (index >= marqueeLength) {
                item.setAttribute('aria-hidden', 'true')
            }
        })

        let translateX = `-${marqueeWidth}`

        if (document.documentElement.getAttribute('dir') === 'rtl') {
            translateX = `${marqueeWidth}`
        }

        let style = `
            <style>
                #marquee-${list.dataset.sectionId} ul {
                    animation-name: marquee-animation-${list.dataset.sectionId};
                    animation-duration: ${list.dataset.animationDuration}s;
                }
                @keyframes marquee-animation-${list.dataset.sectionId} {
                    to { transform: translateX(${translateX}px); }
                }
            </style>
        `
        if (list.dataset.marqueeDirection === 'right') {
            style += `
                <style>
                    @keyframes marquee-animation-${list.dataset.sectionId} {
                        from { transform: translateX(${translateX}px); }    
                        to { transform: translateX(0); }    
                    }
                </style>
            `
        }

        list.insertAdjacentHTML('beforeBegin', style)

        runWhenVisible(section, () => {
            list.style.animationPlayState = ''
        }, () => {
            list.style.animationPlayState = 'paused'
        }, '80px 0px')
    })
}
initMarqueeSections()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.marquee')) {
        initMarqueeSections(e.target)
    }
})


// Lazy load HTMl5 videos
// https://web.dev/lazy-loading-video/
const initVideoLazyLoad = () => {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy-video'))

    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source]
                        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                            videoSource.src = videoSource.dataset.src
                        }
                    }

                    video.target.load()

                    if (video.target.hasAttribute('data-poster')) {
                        video.target.poster = video.target.dataset.poster
                    }

                    video.target.classList.remove('lazy-video')
                    lazyVideoObserver.unobserve(video.target)
                }
            })
        }, { threshold: 0, rootMargin: '0px 0px 200px 0px' })

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo)
        })
    }
}
initVideoLazyLoad()


/*
    Product/cart recommendations navigation on native responsive scrolling
*/
const productRecommendationsResizeObserver = 'ResizeObserver' in window ? new ResizeObserver(entries => {
    entries.forEach(entry => {
        const slider = entry.target.closest('[data-product-recommendations-slider]')
        if (slider) initProductRecommendationsNavigation(slider)
    })
}) : null

const initProductRecommendationsNavigation = (root = document) => {
    const sliders = []

    if (root.matches?.('[data-product-recommendations-slider]')) {
        sliders.push(root)
    }

    root.querySelectorAll?.('[data-product-recommendations-slider]').forEach(slider => sliders.push(slider))

    sliders.forEach(slider => {
        const track = slider.querySelector('[data-product-recommendations-track]')
        const previousButton = slider.querySelector('[data-product-recommendations-arrow="previous"]')
        const nextButton = slider.querySelector('[data-product-recommendations-arrow="next"]')

        if (!track || !previousButton || !nextButton) return

        if (productRecommendationsResizeObserver && slider.dataset.productRecommendationsResizeObserved !== 'true') {
            slider.dataset.productRecommendationsResizeObserved = 'true'
            productRecommendationsResizeObserver.observe(track)
        }

        if (track.clientWidth <= 2) {
            previousButton.disabled = true
            nextButton.disabled = false
            return
        }

        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth)
        const hasOverflow = maximumScroll > 2

        slider.classList.toggle('is-scrollable', hasOverflow)
        previousButton.disabled = !hasOverflow || track.scrollLeft <= 2
        nextButton.disabled = !hasOverflow || track.scrollLeft >= maximumScroll - 2
    })
}

const getProductRecommendationsScrollAmount = track => {
    const cards = track.querySelectorAll('.product-list > .product-item, .mini-cart__recommendations-list > .product-item')

    if (cards.length > 1) {
        const firstCardLeft = cards[0].getBoundingClientRect().left
        const secondCardLeft = cards[1].getBoundingClientRect().left
        const cardDistance = Math.abs(secondCardLeft - firstCardLeft)

        if (cardDistance > 0) return cardDistance
    }

    if (cards.length === 1) {
        return cards[0].getBoundingClientRect().width
    }

    return Math.max(1, track.clientWidth * 0.8)
}

document.addEventListener('click', event => {
    const button = event.target.closest('[data-product-recommendations-arrow]')
    if (!button) return

    const slider = button.closest('[data-product-recommendations-slider]')
    const track = slider?.querySelector('[data-product-recommendations-track]')
    if (!track) return

    const direction = button.dataset.productRecommendationsArrow === 'previous' ? -1 : 1
    track.scrollBy({
        left: direction * getProductRecommendationsScrollAmount(track),
        behavior: 'smooth'
    })
})

document.addEventListener('scroll', event => {
    if (!event.target.matches?.('[data-product-recommendations-track]')) return
    window.requestAnimationFrame(() => initProductRecommendationsNavigation(event.target.closest('[data-product-recommendations-slider]')))
}, true)

window.addEventListener('resize', () => {
    window.requestAnimationFrame(() => initProductRecommendationsNavigation())
})

let productRecommendationsNavigationFrame
const productRecommendationsNavigationObserver = new MutationObserver(mutations => {
    if (productRecommendationsResizeObserver) {
        mutations.forEach(mutation => Array.from(mutation.removedNodes).forEach(node => {
            if (node.nodeType !== 1) return

            if (node.matches?.('[data-product-recommendations-track]')) {
                productRecommendationsResizeObserver.unobserve(node)
            }

            node.querySelectorAll?.('[data-product-recommendations-track]').forEach(track => productRecommendationsResizeObserver.unobserve(track))
        }))
    }

    const hasProductRecommendationsChange = mutations.some(mutation => Array.from(mutation.addedNodes).some(node => {
        return node.nodeType === 1 && (
            node.matches?.('[data-product-recommendations-slider], [data-product-recommendations-track]') ||
            node.querySelector?.('[data-product-recommendations-slider], [data-product-recommendations-track]')
        )
    }))

    if (!hasProductRecommendationsChange) return

    window.cancelAnimationFrame(productRecommendationsNavigationFrame)
    productRecommendationsNavigationFrame = window.requestAnimationFrame(() => initProductRecommendationsNavigation())
})

initProductRecommendationsNavigation()
productRecommendationsNavigationObserver.observe(document.documentElement, { childList: true, subtree: true })
